import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Constants from '../../utils/constants';
import { authHeader } from '../../utils/headers';

function getApiBase() {
  try {
    const u = new URL(Constants.API_ROUTE_REPORTING_TOURNEES);
    return `${u.protocol}//${u.host}`;
  } catch (e) {
    return import.meta.env.VITE_APIURL || '';
  }
}

export const reportingTourneesApi = createApi({
  reducerPath: 'reportingTourneesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiBase(),
    prepareHeaders: (headers) => {
      const token = authHeader();
      if (typeof token === 'string' && token) {
        headers.set('authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['ReportingTournee'],
  endpoints: (builder) => ({
    getReportings: builder.query({
      query: (filters = {}) => {
        const base = Constants.API_ROUTE_REPORTING_TOURNEES;
        const params = new URLSearchParams();
        if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
        if (filters.dateTo) params.set('dateTo', filters.dateTo);
        if (filters.client) params.set('client', String(filters.client));
        if (filters.operateur) params.set('operateur', String(filters.operateur));
        if (filters.laveuse) params.set('laveuse', String(filters.laveuse));
        const qs = params.toString();
        return qs ? `${base}?${qs}` : base;
      },
      transformResponse: (response) => (Array.isArray(response) ? response : []),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'ReportingTournee', id })),
              { type: 'ReportingTournee', id: 'LIST' },
            ]
          : [{ type: 'ReportingTournee', id: 'LIST' }],
    }),
    patchObservation: builder.mutation({
      query: ({ id, observation }) => ({
        url: Constants.API_ROUTE_REPORTING_TOURNEE.replace(':id', id),
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: { observation },
      }),
      invalidatesTags: [{ type: 'ReportingTournee', id: 'LIST' }],
    }),
  }),
});

export const { useGetReportingsQuery, usePatchObservationMutation } = reportingTourneesApi;
